class CountdownTimer {
    constructor ( el, targetDate ) {
        this.el = el;
        this.targetDate = targetDate;
        this.countDownDate = this.targetDate.getTime();

        this.noopEl = document.createElement( 'div' );

        this.daysEl = this.el.querySelector( '[data-countdown="days"]' ) || this.noopEl;
        this.hoursEl = this.el.querySelector( '[data-countdown="hours"]' ) || this.noopEl;
        this.minutesEl = this.el.querySelector( '[data-countdown="minutes"]' ) || this.noopEl;
        this.secondsEl = this.el.querySelector( '[data-countdown="seconds"]' ) || this.noopEl;
        this.intervalId = null;

        // observe changes on data attributes to restart timer if needed
        const observer = new MutationObserver( ( mutationsList ) => {
            for ( const mutation of mutationsList ) {
                if ( mutation.type === 'attributes' && mutation.attributeName === 'data-countdown-target' ) {
                    const newDateStr = this.el.getAttribute( 'data-countdown-target' );
                    const newDate = new Date( newDateStr );
                    if ( !isNaN( newDate ) ) {
                        this.targetDate = newDate;
                        this.countDownDate = this.targetDate.getTime();
                        clearInterval( this.intervalId );
                        this.start();
                    }
                }
            }
        } );

        observer.observe( this.el, {attributes: true} );

    }

    formatValue ( num ) {
        if ( !num || num < 0 ) {
            num = 0;
        }

        return num < 10 ? `0${num}` : num;
    }

    setTimeLabelState ( target, value ) {
        this.setView( target, value );
        this.setValue( target, value );
    }

    setView ( target, value ) {
        target.classList.toggle( 'hidden', value === '' || value == null );
    }

    setValue ( target, value ) {
        const el = target.querySelector( '[data-countdown-value]' );
        if ( el ) {
            el.textContent = this.formatValue( value );
        }
    }

    getTimeUnits ( distance, useTotalHours ) {
        if ( useTotalHours ) {
            const totalHours = Math.floor( distance / (1000 * 60 * 60) );
            const minutes = Math.floor( (distance % (1000 * 60 * 60)) / (1000 * 60) );
            const seconds = Math.floor( (distance % (1000 * 60)) / 1000 );
            return {days: null, hours: totalHours, minutes, seconds};
        }
        else {
            const days = Math.floor( distance / (1000 * 60 * 60 * 24) );
            const hours = Math.floor( (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60) );
            const minutes = Math.floor( (distance % (1000 * 60 * 60)) / (1000 * 60) );
            return {days, hours, minutes, seconds: null};
        }
    };

    start () {
        this.intervalId = setInterval( () => {
            const seventyTwoHoursMs = 72 * 60 * 60 * 1000;
            const now = Date.now();
            const distance = this.countDownDate - now;
            const useTotalHours = distance <= seventyTwoHoursMs;
            const {days, hours, minutes, seconds} = this.getTimeUnits( distance, useTotalHours );

            this.setTimeLabelState( this.daysEl, days );
            this.setTimeLabelState( this.hoursEl, hours );
            this.setTimeLabelState( this.minutesEl, minutes );
            this.setTimeLabelState( this.secondsEl, seconds );

            if ( distance < 0 ) {
                clearInterval( this.intervalId );
            }
        }, 1000 );
    }
}

export default CountdownTimer;